import { paymentReq, warehousingReq } from './index'
import store from '@/store'
const deviceioProid = process.env.VUE_APP_WarehousingProjectid

/**
 * 获取即将到期的设备
 */
export function QueryExpiringSoonDevices () {
  return warehousingReq({
    url: '/api/Payment/QueryExpiringSoonDevicesBlueSpider',
    method: 'POST',
    headers: {
      'userid': store.getters.id
    }
  })
}

/**
 * 获取设备充值价格列表
 * @returns
 */
export function DevicePriceList () {
  return paymentReq({
    url: '/api/Price/DevicePriceList',
    method: 'GET'
  })
}

/**
 * 获取短信充值套餐
 */
export function SmsPriceList () {
  return paymentReq({
    url: '/api/Price/SmsPriceList',
    method: 'GET'
  })
}

/**
 * 根据终端用户的账号分页获取采集器列表
 * @param {number} limit 页大小
 * @param {number} offset 页码
 * @param {string} userid 终端用户主键
 * @returns
 */
export function QueryGatewaysByUser () {
  return warehousingReq({
    url: '/api/Payment/QueryBlueSpiderGatewaysByUser',
    method: 'POST',
    data: {
      userid: store.getters.id,
      platform: 'bluespider'
    }
  })
}

/**
 * 创建支付宝支付token
 * @param {string} userid 终端账号主键
 * @returns
 */
export function CreateAliPayToken (userid) {
  return paymentReq({
    url: '/api/Account/CreateAliPayToken',
    method: 'GET',
    params: {
      projectId: deviceioProid,
      projectUserId: userid,
      payClient: 1
    }
  })
}

/**
 * 设备充值
 * @param {object} data { payOrderTitle: string; payTotalAmount: Record<string, unknown>; devicenumberlist: Record<string, unknown>[]; rechargePriceId: string; }
 * @param {string} token 支付token
 * @returns
 */
export function DeviceRecharge (data, token) {
  return paymentReq({
    url: '/api/AliPay/DeviceRecharge',
    method: 'POST',
    data: data,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
}

/**
 * 短信充值
 * @param {object} data { payOrderTitle: string; payTotalAmount: Record<string, unknown>; devicenumberlist: Record<string, unknown>[]; rechargePriceId: string; }
 * @param {string} token 支付token
 * @returns
 */
export function SmsRecharge (data, token) {
  return paymentReq({
    url: '/api/AliPay/SmsRecharge',
    method: 'POST',
    data: data,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
}

/**
 * 获取订单状态
 * @param {string} orderNumber 订单编号
 * @param {string} token  支付token
 */
export function QueryOrderStatus (orderNumber, token) {
  return paymentReq({
    url: '/api/AliPay/QueryOrderStatus',
    method: 'GET',
    params: {
      outTradeNo: orderNumber
    },
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
}
